export default __webpack_public_path__ + "static/media/key-feature-tests.bcb5a35e.png";